import { Reveal, Eyebrow } from "../components/Reveal";
import { CLIENTS } from "../data/content";

export const About = () => (
  <section id="about" data-testid="about-section" className="bg-[#F8F9FA] py-24 lg:py-36">
    <div className="max-w-7xl mx-auto px-6 sm:px-10">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-7">
          <Reveal>
            <Eyebrow>About Calliope</Eyebrow>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.12] text-[#0A0F1D] mt-6">
              Advancing science requires <em className="italic text-teal-700">more than scientific expertise.</em>
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 text-lg text-slate-600 leading-relaxed max-w-2xl">
              Moving promising science forward requires the right development strategy, clinical
              expertise, regulatory insight, organizational capabilities and connections.
            </p>
            <p className="mt-6 text-base text-slate-600 leading-relaxed max-w-2xl">
              We help life sciences organizations bring these elements together to navigate complex
              decisions and advance their programs.
            </p>
            <p className="mt-6 text-base text-slate-600 leading-relaxed max-w-2xl">
              Calliope is a life sciences strategic advisory firm that helps organizations
              advance scientific innovation by connecting the people, expertise and capabilities
              required to navigate scientific development, clinical programs, regulatory pathways
              and organizational growth. Founded by Dr. Launa Aspeslet, the firm draws on decades
              of senior leadership experience across biotechnology, pharmaceuticals and clinical
              research.
            </p>
          </Reveal>
        </div>

        <div className="lg:col-span-5">
          <Reveal delay={0.25}>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-slate-500 mb-6">
              Who we serve
            </p>
            <ul className="divide-y divide-slate-200" data-testid="about-clients-list">
              {CLIENTS.map((c, i) => (
                <li
                  key={c}
                  className="flex items-baseline gap-4 py-3.5 group"
                >
                  <span className="font-mono text-[11px] text-teal-700/80">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="text-[15px] text-slate-700 group-hover:text-[#0B132B] group-hover:translate-x-1 transition-[color,transform] duration-300">
                    {c}
                  </span>
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
